<div *ngIf="isPageReady" class="flex flex-col gap-3 p-4">
  <div class="flex items-center gap-2">
    <input #firstInput pInputText class="flex-1" title="Question" [(ngModel)]="question" [disabled]="isExplaining"
      placeholder="Optional. Type a question about this job order." (keydown.enter)="explain()" />
    <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-comment" [disabled]="isExplaining"
      (click)="explain()">
      <span>{{ question.trim() ? "Ask" : "Explain Again" }}</span>
    </button>
  </div>

  <div *ngIf="isExplaining" class="flex items-center gap-3 p-4">
    <p-progressSpinner styleClass="w-8 h-8" strokeWidth="4"></p-progressSpinner>
    <span>The assistant reads the job order. This takes about 30 seconds.</span>
  </div>

  <div *ngIf="errorMessage && !isExplaining" class="p-3 rounded-lg text-red-500">{{ errorMessage }}</div>

  <div *ngIf="result && !isExplaining" class="explain-job-order-answer qb-detail-card p-4 overflow-auto max-h-[60vh]">
    <markdown [data]="result.Answer"></markdown>
  </div>

  <div *ngIf="result && !isExplaining" class="text-xs" style="color: var(--p-text-muted-color, rgba(0, 0, 0, 0.6))">
    The assistant only reads data. It does not change the job order. Check important facts before you act.
    ({{ result.ToolCalls }} lookups, {{ result.InputTokens + result.OutputTokens | number }} tokens, {{ result.Seconds }} s)
  </div>

  <div class="flex justify-start border-t pt-3">
    <button pButton type="button" class="p-button-raised" (click)="close()"><span>Close</span></button>
  </div>
</div>
